// refactor with id so we don't depend on model
import i18n from 'modules/core/lib/i18n'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import type JobRole from 'modules/job_catalog/store/models/JobRole'

export type JobRoleWarningType = 'notInLegalEntity' | 'archived'
export interface JobRoleWarning {
  type: JobRoleWarningType
  warning: string
}

export const getRoleWarning = (
  role: JobRole | undefined,
  legalEntity: LegalEntity | undefined
): JobRoleWarning | null => {
  if (!role) {
    return null
  }

  if (role.isArchived) {
    return {
      type: 'archived',
      warning: i18n.t('job_catalog.job_role_archived'),
    }
  }

  if (legalEntity && !role.isRoleInLegalEntity(legalEntity)) {
    return {
      type: 'notInLegalEntity',
      warning: i18n.t('job_catalog.job_role_no_legal_entity'),
    }
  }

  return null
}
